import React, { useEffect, useState } from 'react'
import Proptypes from 'prop-types'
import { Modal, Button } from 'semantic-ui-react'
import Swal from 'sweetalert2'
import { DeleteHierarchy } from '../../../../services/asset'
import { primaryColor } from '../../../../constants'

const DeleteHierarchyModal = (props) => {
  console.log('Delete level: ', props.level)
  const [open, setOpen] = useState(false)
  useEffect(() => {
    setOpen(props.openDelete)
  }, [props.openDelete])

  useEffect(() => {
    props.getDeleteModalState(open)
  }, [open])

  const handleDelete = async () => {
    Swal.showLoading()
    const queryParams = {
      levelType: props.level.levelType,
    }
    const res = await DeleteHierarchy(queryParams, props.level.id)
    if (res.success) {
      await Swal.fire('Level Deleted Successfully', '', 'success')
      setOpen(false)
    } else {
      Swal.fire(res.msg || 'Error Deleting Level', '', 'error')
    }
  }
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        style={{ width: '450px' }}
      >
        <Modal.Header style={{ backgroundColor: '#303D54', color: '#FFF' }}>
          Delete {props.level.label || props.level.name}
        </Modal.Header>
        <Modal.Content>
          <h3>Are you sure you want to delete this level</h3>
          <Button
            style={{ backgroundColor: 'red', color: 'white' }}
            onClick={handleDelete}
          >
            Yes
          </Button>
        </Modal.Content>
        <Modal.Actions>
          <Button
            style={{ backgroundColor: primaryColor, color: 'white' }}
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

DeleteHierarchyModal.propTypes = {
  openDelete: Proptypes.bool,
  getDeleteModalState: Proptypes.func,
  level: Proptypes.object,
}

export default DeleteHierarchyModal
